import { FormType } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';

export const formTypeColorName = (type: FormType): [string, string] => {
  switch (type) {
    case FormType.Participant:
      return ['green', 'Participant'];
  }
};

interface Props extends ChakraV3.TagProps {
  type: FormType;
}

export const FormTypeTag = (props: Props) => {
  const { type, ...rest } = props;

  const [color, label] = formTypeColorName(type);

  return (
    <ChakraV3.Tag size='sm' colorPalette={color} {...rest}>
      {label}
    </ChakraV3.Tag>
  );
};
